/**
 * @generated SignedSource<<98b7d60e1412665813eeb351f05535af>>
 * @relayHash 85c94a305df55a8f9bcea07af2281ddb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6ce2465468a24d8b1abc73e95d8a85299a4c30f8b98de67001a7e26479bbe800

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_autodevAgentPickerBulkQuery$variables = {
  cloudId: string;
};
export type ui_autodevAgentPickerBulkQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pickerContent_autodevAgentPicker_agentsFragRef">;
};
export type ui_autodevAgentPickerBulkQuery = {
  response: ui_autodevAgentPickerBulkQuery$data;
  variables: ui_autodevAgentPickerBulkQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider": isVerticalsAgentPickerEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider: {
    readonly get: () => boolean;
  };
});

import isVerticalsAgentPickerEnabled_provider from '@atlassian/jira-relay-provider/src/autodev-is-verticals-agent-picker-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ui_autodevAgentPickerBulkQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "pickerContent_autodevAgentPicker_agentsFragRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "ui_autodevAgentPickerBulkQuery",
    "selections": [
      {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 20
              }
            ],
            "concreteType": "DevAiRovoAgentConnection",
            "kind": "LinkedField",
            "name": "devai_autodevRovoAgents",
            "plural": false,
            "selections": [
              {
                "concreteType": "DevAiRovoAgentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "DevAiRovoAgent",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "identityAccountId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "externalConfigReference"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "devai_autodevRovoTemplates",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              },
              {
                "kind": "Literal",
                "name": "templatesFilter",
                "value": "ONLY"
              }
            ],
            "concreteType": "DevAiRovoAgentConnection",
            "kind": "LinkedField",
            "name": "devai_autodevRovoAgents",
            "plural": false,
            "selections": [
              {
                "concreteType": "DevAiRovoAgentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "DevAiRovoAgent",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6ce2465468a24d8b1abc73e95d8a85299a4c30f8b98de67001a7e26479bbe800",
    "metadata": {},
    "name": "ui_autodevAgentPickerBulkQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider": isVerticalsAgentPickerEnabled_provider
    }
  }
};
})();

(node as any).hash = "2b0f71dc0fd59f04cda922f89868fe47";

export default node;
